import { Modal } from 'antd';
import { useAiChat } from './AiChatProvider';
import { aiChatFeatures } from '../models/aiChatFeatures';
import { sessionIsCurrent, sessionTicket } from '../../../utils/sessionLifecycle';
export function useAiChatActions() {
  const { store }=useAiChat(); const [modal,holder]=Modal.useModal();
  const beforeLeave = work => {
    const snapshot=store?.getSnapshot(),id=snapshot?.activeId;
    if (!aiChatFeatures.incognitoDelete || !id || !snapshot.details[id]?.chat.incognito) { work(); return; }
    const ticket=sessionTicket();
    modal.confirm({ title:'End this incognito chat? It will be deleted.',okText:'End chat',okButtonProps:{danger:true},onOk:async () => { if (!sessionIsCurrent(ticket)) return; await store.endIncognito(id); if (sessionIsCurrent(ticket)) work(); } });
  };
  const requestDelete = chat => {
    if (!aiChatFeatures.incognitoDelete || !store) return;
    const ticket=sessionTicket();
    modal.confirm({ title:"Delete this chat for good? This can't be undone.",okText:'Delete',okButtonProps:{danger:true},onOk:async () => { if (sessionIsCurrent(ticket)) await store.deleteChat(chat.id); } });
  };
  return { holder,beforeLeave,requestDelete,newChat:title => beforeLeave(() => store.newChat(title)),closeDock:() => beforeLeave(() => store.hideDock()),select:id => beforeLeave(() => store.select(id)) };
}
